import { withHook } from 'utils/withHook';
import { useCompetitionsPreviewFooterState } from 'containers/CompetitionsPreviewFooter/logic/useCompetitionsPreviewFooterState';
import { CompetitionsPreviewFooterView } from 'containers/CompetitionsPreviewFooter/view/CompetitionsPreviewFooterView';

export const CompetitionsPreviewFooter = withHook(
  useCompetitionsPreviewFooterState
)(CompetitionsPreviewFooterView);
